import React from 'react';
import { Button, Modal } from '@/components';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  subtitle?: string;
  description?: string;
  confirmText?: string;
  isLoading?: boolean;
}

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Delete Item?',
  subtitle = 'This action cannot be undone.',
  description = 'Are you sure you want to delete this item? All associated data will be removed.',
  confirmText = 'Delete',
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      icon="ri-alert-line"
      iconTone="danger"
      title={title}
      subtitle={subtitle}
      width="sm"
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button variant="white" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Deleting…' : confirmText}
          </Button>
        </div>
      }
    >
      <p className="text-sm text-text-sub-600 leading-relaxed">{description}</p>
    </Modal>
  );
};

export default DeleteConfirmModal;
